export type DashboardRangeOption = {
  id: string;
  title: string;
};

export const PLAYERS_DASHBOARD_RANGE_OPTIONS: DashboardRangeOption[] = [
  { id: 'all', title: 'All' },
  { id: '1W', title: '1W' },
  { id: '1M', title: '1M' },
  { id: '3M', title: '3M' },
  { id: '6M', title: '6M' },
  { id: '1Y', title: '1Y' },
  { id: 'custom', title: 'Custom' },
];

